module.exports = __webpack_public_path__ + "static/media/favicon.951d0048.ico";